var iconSize = [11, 14, 16, 20, 24];
iconSize.xs = iconSize[0];
iconSize.sm = iconSize[1];
iconSize.md = iconSize[2];
iconSize.lg = iconSize[3];
iconSize.xl = iconSize[4];
export { iconSize };
//# sourceMappingURL=iconSizes.js.map